var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167AE",
    d: "M5 4.5A2.5 2.5 0 0 0 2.5 7v10.5l.01.34q0 .34.15.82A1.87 1.87 0 0 0 4.5 20H19a2.5 2.5 0 0 0 2.5-2.5V11A2.5 2.5 0 0 0 19 8.5h-.5v-.19a2.5 2.5 0 0 0-2.5-2.5h-4.22c-.35 0-.67-.16-.87-.44a2 2 0 0 0-1.69-.87zM6.2 19q.1-.17.15-.34a3 3 0 0 0 .16-1.16v-.03H6.5V11c0-.83.67-1.5 1.5-1.5h11c.83 0 1.5.67 1.5 1.5v6.5c0 .83-.67 1.5-1.5 1.5zm-.69-1.4a2 2 0 0 1-.1.74q-.1.3-.3.47-.17.17-.6.19a1 1 0 0 1-.6-.2 1 1 0 0 1-.3-.46 2 2 0 0 1-.1-.8l-.01-.12V7c0-.83.67-1.5 1.5-1.5h4.22c.35 0 .67.17.87.45.4.54 1.02.86 1.69.86H16c.83 0 1.5.67 1.5 1.5v.19H8A2.5 2.5 0 0 0 5.5 11v6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.af0261d04ad529c43f55e679f721fd41.svg";
export { ForwardRef as ReactComponent };